import React, { Fragment, useEffect, useState } from "react";
import { Form, Table } from "react-bootstrap";
import { Authorities } from "../../../../../_helpers/Helpers";

export function UserAuthorizationEditForm({
  modules,
  isSuperAdmin,
  userGroupAuthorities,
  moduleAndAuthorities,
  btnRef,
  saveAuthorities
}) {
  const [authorityIds, setAuthorityIds] = useState([]);
  const parentModules = modules && modules.filter(module => module.parentId === 0);

  useEffect(() => {
    if (isSuperAdmin) {
      const allAuthorities = [];
      modules.forEach(module => {
        module.authorityIds.forEach(id => allAuthorities.push([module.id, id].toString()));
      });
      setAuthorityIds(allAuthorities);
    } else {
      setAuthorityIds(moduleAndAuthorities);
    }    
  }, [isSuperAdmin, modules, moduleAndAuthorities]);

  return (
    <Form onSubmit={(e) => {
      e.preventDefault();
      saveAuthorities(authorityIds);
    }}>
      <Table responsive>
        <thead>
          <tr>
            <th className="text-center">Modüller</th>
            <th className="text-center">Tümü</th>
            {
              Authorities.map(authority => (
                <th key={authority.name} className="text-center">{authority.definition}</th>
              ))
            }            
          </tr>
        </thead>
        {
          modules && modules.length > 0 &&
          <tbody>
          {
            parentModules && parentModules.map(module => {
              const allAuthorities = [];
              module.authorityIds.forEach(id => allAuthorities.push([module.id, id].toString()));
              const childModules = modules.filter(childModule => childModule.parentId === module.id);
              const allUserAuthorities = allAuthorities.filter(authority => !userGroupAuthorities.includes(authority));
                           
              return (
                <Fragment key={module.key}>
                  <tr>
                    <th>{module.name}</th>                        
                    <td>
                      {
                        childModules.length > 0 ?
                        ""
                        :
                        <Form.Check
                          type="checkbox"
                          className="text-center"
                          onChange={e => {
                            allUserAuthorities.forEach(authority => {
                              if (e.target.checked) {
                                if (!authorityIds.includes(authority)) setAuthorityIds(ids => [...ids, authority]);
                              } else {
                                if (authorityIds.includes(authority)) setAuthorityIds(ids => ids.filter(id => id !== authority));
                              }
                            });
                          }}
                        />
                      }
                    </td>
                    {
                      Authorities.map(authority => (
                        <td key={authority.name}>
                          {
                            childModules.length > 0 ?
                            ""
                            :
                            <Form.Check 
                              type="checkbox"
                              className="text-center"
                              value={[module.id, authority.id]}
                              checked={
                                (isSuperAdmin && module.authorityIds.includes(authority.id)) ||
                                authorityIds.includes([module.id, authority.id].toString())
                              }
                              disabled={
                                isSuperAdmin ||
                                !module.authorityIds.includes(authority.id) || 
                                userGroupAuthorities.includes([module.id, authority.id].toString())
                              }
                              onChange={e => {
                                const value = e.target.value;
                                setAuthorityIds(ids => ids.includes(value) ? ids.filter(id => id !== value) : [...ids, value]);
                              }}
                            />
                          }
                        </td>
                      ))
                    }
                  </tr>
                  {
                    childModules.map(module => {
                      const allAuthorities = [];
                      module.authorityIds.forEach(id => allAuthorities.push([module.id, id].toString()));
                      const allUserAuthorities = allAuthorities.filter(authority => !userGroupAuthorities.includes(authority));

                      return (
                        <tr key={module.key}>
                          <td>{module.name}</td>
                          <td>
                            <Form.Check                              
                              type="checkbox"
                              className="text-center"
                              onChange={e => {
                                allUserAuthorities.forEach(authority => {
                                  if (e.target.checked) {
                                    if (!authorityIds.includes(authority)) setAuthorityIds(ids => [...ids, authority]);
                                  } else {
                                    if (authorityIds.includes(authority)) setAuthorityIds(ids => ids.filter(id => id !== authority));
                                  }                                    
                                });
                              }}
                            />
                          </td>
                          {
                            Authorities.map(authority => (
                              <td key={authority.name}>
                                <Form.Check 
                                  type="checkbox"
                                  className="text-center"
                                  value={[module.id, authority.id]}
                                  checked={
                                    (isSuperAdmin && module.authorityIds.includes(authority.id)) ||
                                    authorityIds.includes([module.id, authority.id].toString())
                                  }
                                  disabled={
                                    isSuperAdmin ||
                                    !module.authorityIds.includes(authority.id) || 
                                    userGroupAuthorities.includes([module.id, authority.id].toString())
                                  }
                                  onChange={e => {
                                    const value = e.target.value;
                                    setAuthorityIds(ids => ids.includes(value) ? ids.filter(id => id !== value) : [...ids, value]);
                                  }}
                                />
                              </td>
                            ))
                          }
                        </tr>
                      );
                    })
                  }
                </Fragment>
              );
            })
          }
          </tbody>
        }
      </Table>

      <button
        type="submit"
        style={{ display: "none" }}
        ref={btnRef}
      />
    </Form>
  );
}